import { render, staticRenderFns } from "./ListCategories.vue?vue&type=template&id=409444f0&"
import script from "./ListCategories.vue?vue&type=script&lang=js&"
export * from "./ListCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports